import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '~/ui/table'
import { Button } from '~/ui/button'
import { Badge } from '~/ui/badge'
import { Download, ExternalLink } from 'lucide-react'
import { format } from 'date-fns'
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '~/ui/card'
interface InvoicesTableProps {
  invoices: Array<{
    id: string
    amount: number
    status: string
    createdAt: string
    pdfUrl: string | null
    hostedInvoiceUrl: string | null
    number: string | null
  }>
  loading: boolean
}

export const InvoicesTable: React.FC<InvoicesTableProps> = ({ invoices, loading }) => {
  if (loading) {
    return <div className="text-center py-8">Loading invoices...</div>
  }

  if (invoices.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-600">No invoices found</p>
      </div>
    )
  }

  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'paid':
        return <Badge variant="default" className="bg-green-500">Paid</Badge>
      case 'open':
        return <Badge variant="outline">Open</Badge>
      case 'void':
        return <Badge variant="secondary">Void</Badge>
      default:
        return <Badge variant="outline">{status}</Badge>
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Invoices</CardTitle>
        <CardDescription>View and download your billing invoices</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Invoice #</TableHead>
              <TableHead>Date</TableHead>
              <TableHead>Amount</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {invoices.map((invoice) => (
              <TableRow key={invoice.id}>
                <TableCell className="font-medium">
                  {invoice.number || invoice.id.slice(0, 8)}
                </TableCell>
                <TableCell>
                  {format(new Date(invoice.createdAt), 'MMM d, yyyy')}
                </TableCell>
                <TableCell>${(invoice.amount / 100).toFixed(2)}</TableCell>
                <TableCell>{getStatusBadge(invoice.status)}</TableCell>
                <TableCell className="text-right">
                  <div className="flex justify-end gap-2">
                    {invoice.hostedInvoiceUrl && (
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => window.open(invoice.hostedInvoiceUrl ?? '', '_blank')}
                      >
                        <ExternalLink className="mr-2 h-4 w-4" />
                        View
                      </Button>
                    )}
                    {invoice.pdfUrl && (
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => window.open(invoice.pdfUrl ?? '', '_blank')}
                      >
                        <Download className="mr-2 h-4 w-4" />
                        PDF
                      </Button>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )
}

